export * from "./loyalty-card.component";
